/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Conversion_Error_Too_Many_AttemptsInputs */

const en_conversion_error_too_many_attempts = /** @type {(inputs: Conversion_Error_Too_Many_AttemptsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This document could not be processed after several attempts. Please contact support.`)
};

const es_conversion_error_too_many_attempts = /** @type {(inputs: Conversion_Error_Too_Many_AttemptsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudo procesar este documento tras varios intentos. Contacta con soporte.`)
};

/**
* | output |
* | --- |
* | "This document could not be processed after several attempts. Please contact support." |
*
* @param {Conversion_Error_Too_Many_AttemptsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const conversion_error_too_many_attempts = /** @type {((inputs?: Conversion_Error_Too_Many_AttemptsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Conversion_Error_Too_Many_AttemptsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_conversion_error_too_many_attempts(inputs)
	return en_conversion_error_too_many_attempts(inputs)
});